import type { CoinOverall } from '@/types/coin'

const supportedTimeZones = [
  {
    name: 'Pacific/Honolulu',
    offset: -10 * 60,
  },
  {
    name: 'America/Juneau',
    offset: -9 * 60,
  },
  {
    name: 'America/Los_Angeles',
    offset: -8 * 60,
  },
  {
    name: 'America/Denver',
    offset: -7 * 60,
  },
  {
    name: 'America/Chicago',
    offset: -6 * 60,
  },
  {
    name: 'America/Toronto',
    offset: -5 * 60,
  },
  {
    name: 'America/Caracas',
    offset: -4 * 60,
  },
  {
    name: 'America/Argentina/Buenos_Aires',
    offset: -3 * 60,
  },
  {
    name: 'Europe/London',
    offset: 0,
  },
  {
    name: 'Europe/Brussels',
    offset: 1 * 60,
  },
  {
    name: 'Europe/Athens',
    offset: 2 * 60,
  },
  {
    name: 'Europe/Moscow',
    offset: 3 * 60,
  },
  {
    name: 'Asia/Tehran',
    offset: 3.5 * 60,
  },
  {
    name: 'Asia/Dubai',
    offset: 4 * 60,
  },
  {
    name: 'Asia/Karachi',
    offset: 5 * 60,
  },
  {
    name: 'Asia/Kolkata',
    offset: 5.5 * 60,
  },
  {
    name: 'Asia/Almaty',
    offset: 6 * 60,
  },
  {
    name: 'Asia/Jakarta',
    offset: 7 * 60,
  },
  {
    name: 'Asia/Hong_Kong',
    offset: 8 * 60,
  },
  {
    name: 'Asia/Tokyo',
    offset: 9 * 60,
  },
  {
    name: 'Australia/Brisbane',
    offset: 10 * 60,
  },
  {
    name: 'Australia/Adelaide',
    offset: 10.5 * 60,
  },
  {
    name: 'Australia/Sydney',
    offset: 11 * 60,
  },
  {
    name: 'Pacific/Norfolk',
    offset: 12 * 60,
  },
  {
    name: 'Pacific/Auckland',
    offset: 13 * 60,
  },
  {
    name: 'Pacific/Chatham',
    offset: 13.75 * 60,
  },
]

const getTimeZone = () => {
  // Get number of minutes offset from UTC
  const offset = -new Date().getTimezoneOffset()
  return (
    supportedTimeZones.find(timeZone => timeZone.offset === offset)?.name ??
    Intl.DateTimeFormat().resolvedOptions().timeZone
  )
}

const EXCHANGE = 'CRYPTOCOM'

const TRADING_VIEW_BASE_CONFIG = {
  allow_symbol_change: true,
  calendar: false,
  details: false,
  hide_side_toolbar: true,
  hide_top_toolbar: false,
  hide_legend: false,
  hide_volume: false,
  hotlist: false,
  interval: 'D',
  locale: 'en',
  save_image: true,
  style: '1',
  theme: 'dark',
  backgroundColor: '#0F0F0F',
  gridColor: 'rgba(242, 242, 242, 0.06)',
  watchlist: [],
  withdateranges: false,
  compareSymbols: [],
  studies: [],
  autosize: true,
}

/**
 * @doc https://www.tradingview.com/widget-docs/widgets/charts/advanced-chart/
 */
export function createTradingViewWidgetScript(coin: CoinOverall, currency: string) {
  const timezone = getTimeZone() ?? 'etc/UTC'
  const script = document.createElement('script')
  script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js'
  script.type = 'text/javascript'
  script.async = true
  const tradingViewConfig = {
    ...TRADING_VIEW_BASE_CONFIG,
    symbol: `${EXCHANGE}:${coin.symbol}${currency}`,
    timezone: timezone,
  }
  script.innerHTML = JSON.stringify(tradingViewConfig)
  return script
}
